"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRowCheckbox = exports.getActionMenuButton = void 0;
var getActionMenuButton = function (rowId, container) {
    var element = container.querySelector("[action-button-row-id=\"".concat(rowId, "\"]"));
    return element ? element : null;
};
exports.getActionMenuButton = getActionMenuButton;
var getRowCheckbox = function (rowId, container) {
    var element = container.querySelector(".ag-row[row-id=\"".concat(rowId, "\"] .ag-checkbox-input"));
    return element ? element : null;
};
exports.getRowCheckbox = getRowCheckbox;
